import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AppConfig from '../../appConfig';

import BusComponent from '../BusComponent';
import DATA_BROWSER_CONFIG from '../../helpers/DataBrowserConfig';
import DataVariablesList from './dataVariables/DataVariablesList';
import MetaVariable from '../../objects/MetaVariable';
import SelectedVariablesChip from './SelectedVariablesChip';

class DataBrowserGroups extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    renderGroupVariables(group) {
        const { mapInstance, currentMetadataSelection, intl } = this.props;
        const { tables } = this.props.dataset;

        if (!group.variables || group.variables.length === 0) {
            return null;
        }

        const variables = group.variables
            .map(variable => {
                const datasetVariable =
                    tables[variable.table] &&
                    tables[variable.table].variables &&
                    tables[variable.table].variables[variable.name]
                        ? tables[variable.table].variables[variable.name]
                        : null;

                if (!datasetVariable) {
                    return null;
                }

                const metaVariable = new MetaVariable();
                Object.assign(metaVariable, datasetVariable);

                // Set the label from the variable definition
                metaVariable.label = variable.label;

                return metaVariable;
            })
            .filter(Boolean); // Filter out null values

        if (variables.length === 0) {
            return (
                <div className="data-browser-group__no-variables">
                    {intl.formatMessage({ id: 'dataBrowser.noVariables' })}
                </div>
            );
        }

        return (
            <DataVariablesList
                variables={variables}
                mapInstanceId={mapInstance.id}
                hasDataFilter={mapInstance.hasDataFilter}
                currentMetadataSelection={currentMetadataSelection}
            />
        );
    }

    renderGroups() {
        const { className, openedGroups, onSetOpenedGroup, currentMetadataSelection } = this.props;

        return DATA_BROWSER_CONFIG.groups.map((group, index) => {
            const isOpen = openedGroups && openedGroups.map(g => g.name).includes(group.name);

            const wrapperClasses = classnames(
                'flex-it column no-shrink padded-vertical-8',
                className,
                index < DATA_BROWSER_CONFIG.groups.length - 1 ? 'border-bottom-light' : '',
            );

            const selectedGroupVariables = currentMetadataSelection.variables
                .filter(variable => group.variables.map(v => v.name).includes(variable.name))
                .map(variable => variable.label);

            return (
                <div key={`group-${index}`} className={wrapperClasses}>
                    <button
                        className="data-browser-group flex-it center space-between"
                        onClick={() => onSetOpenedGroup(group)}
                        aria-expanded={isOpen}
                    >
                        <img
                            className="data-browser-group__icon"
                            alt={group.name}
                            src={`${AppConfig.constants.assetsBaseURL}/svg/dataBrowser/${group.icon}`}
                        />
                        <h6>{group.name}</h6>
                        {!isOpen && <SelectedVariablesChip variables={selectedGroupVariables} />}
                        <div className="data-browser-group__arrow">
                            <i
                                className="material-symbols"
                                aria-label={isOpen ? 'Up arrow icon' : 'Down arrow icon'}
                            >
                                {isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                            </i>
                        </div>
                    </button>
                    {isOpen && this.renderGroupVariables(group)}
                </div>
            );
        });
    }

    render() {
        const { className, dataset } = this.props;

        const containerClasses = classnames(
            'data-browser__content flex-it column stretch justify-center',
            className,
        );

        if (!dataset || !dataset.tables) {
            return <div className={containerClasses}>No dataset</div>;
        }

        return <div className={containerClasses}>{this.renderGroups()}</div>;
    }
}

DataBrowserGroups.propTypes = {
    className: PropTypes.string,
    dataset: PropTypes.object.isRequired,
    mapInstance: PropTypes.object.isRequired,
    currentMetadataSelection: PropTypes.object.isRequired,
    openedGroups: PropTypes.array,
    onSetOpenedGroup: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

DataBrowserGroups.defaultProps = {
    className: '',
    openedGroups: [],
};

export default injectIntl(DataBrowserGroups);
